import PropTypes from "prop-types";
import {
  Actions,
  CloseButton,
  LoudCheck,
  Modal,
  Overlay,
  StyledButton,
  Subtitle,
  TickFrame,
  Title,
} from "./MessageModalStyled";
import { CloseIcon } from "../../../../assets/icons";

const SuccessCheck = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="28" cy="28" r="28" fill="#16A34A" />
    <path
      d="M16.5 29.5L24 37L39.5 19.5"
      stroke="#fff"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function MessageModal({
  open,
  onClose,
  title,
  message,
  buttonText,
  icon,
  onClick,
  showButton = true,
  variant = "confirmation",
}) {
  if (!open) return null;

  const loud = variant === "success";

  return (
    <Overlay $loud={loud}>
      <Modal $loud={loud} role="alertdialog" aria-labelledby="message-modal-title">
        <CloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </CloseButton>
        {loud ? (
          <LoudCheck>
            <SuccessCheck />
          </LoudCheck>
        ) : (
          icon && <TickFrame>{icon}</TickFrame>
        )}
        <Title id="message-modal-title" $loud={loud}>
          {title}
        </Title>
        <Subtitle $loud={loud}>{message}</Subtitle>
        {showButton && (
          <Actions $loud={loud}>
            <StyledButton variant={variant} $loud={loud} onClick={onClick}>
              {buttonText}
            </StyledButton>
          </Actions>
        )}
      </Modal>
    </Overlay>
  );
}

MessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  showButton: PropTypes.bool,
  variant: PropTypes.string,
};
